import { matchPath, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './routes/Home';
import AboutUs from './routes/AboutUs';
import LoadingScreen from './components/LoadingScreen';
import Statute from './routes/Statute';
import Partners from './routes/Partners';
import Footer from './components/Footer';
import ScrollToTop from './utils/ScrollToTop';
import HowItWorks from './routes/HowItWorks';
import Cookies from './components/CookiesPopup';
import React, { useContext, useEffect, useState } from 'react';
import { SprawneMiastoContext } from './components/SprawneMiastoContext';
import MyAccount from './routes/MyAccount';
import ProfileTab from './routes/MyAccount/Tabs/Profile';
import MyReportsTab from './routes/MyAccount/Tabs/MyReports';
import ActivateAccount from './routes/ActivateAccount';
import LanguageTab from './components/LanguageTab';
import Contact from './routes/Contact';
import PageNotFound from './routes/PageNotFound';
import Assign from './routes/AssignDistrict';
import AdminCenter from './routes/AdminCenter';
import LastWords from './components/LastWords';

export default function App() {
    const [loadingScreen, setLoadingScreen] = useState<boolean>(false);
    const Context = useContext(SprawneMiastoContext);
    const { pathname } = useLocation();
    useEffect(() => {
        console.log('App rerender');
    }, []);
    return (
        <div className={'font-rubik'}>
            {(!Context?.user?.adminAccess || !matchPath('/adminCenter/*', pathname)) && (
                <LanguageTab />
            )}
            {
                loadingScreen && <LastWords />
            }
            <ScrollToTop except={['/statute/*']} />
            {(!Context?.user?.adminAccess || !matchPath('/adminCenter/*', pathname)) && (
                <Navbar notAffectOn={['/']} />
            )}

            <Routes>
                <Route path={'/statute/*'} element={<Statute />} />
                <Route
                    index
                    path={'/'}
                    element={
                        <>
                            <LoadingScreen loaded={loadingScreen} setLoaded={setLoadingScreen} />
                            <Home />
                        </>
                    }
                />
                <Route path={'/about-us'} element={<AboutUs />} />
                <Route path={'/partners'} element={<Partners />} />
                <Route path={'/how-it-works'} element={<HowItWorks />} />
                <Route path={'/activate'} element={<ActivateAccount />} />
                <Route path={'/contact'} element={<Contact />} />

                {Context?.user && (
                    <>
                        <Route
                            path={'/my-account'}
                            element={<Navigate to={'/my-account/profile'} />}
                        />
                        <Route path={'/my-account'} element={<MyAccount />}>
                            <Route index={true} path={'profile'} element={<ProfileTab />} />
                            <Route path={'my-reports'} element={<MyReportsTab />} />
                        </Route>
                    </>
                )}

                {Context?.user &&
                    (Context.user.admin.length > 0 || Context.user.moderator.length > 0) && (
                        <Route path={'/adminCenter/*'} element={<AdminCenter />} />
                    )}
                {Context?.user && <Route path={'/assignUser'} element={<Assign />} />}
                <Route path={'*'} element={<PageNotFound />} />
            </Routes>
            <Cookies />

            {(!Context?.user?.adminAccess || !matchPath('/adminCenter/*', pathname)) && <Footer />}
        </div>
    );
}
